// 线型颜色
const lineColor = {
    color: '#29AC4E',
    color0: '#CC1414',
    borderColor: '#29AC4E',
    borderColor0: '#CC1414'
};

export default {
    lineColor
};



// WEBPACK FOOTER //
// ./src/controller/echartsOption/klineStyle.js